import React from "react";
import { Routes, Route } from "react-router-dom";
import Products from "./pages/Products";
import CategoriesAccordion from "./pages/CategoriesAccordion";
import ProductEdit from "./pages/ProductEdit";
import Admin from "./pages/admin/Admin";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import RecipesAdminList from "./pages/RecipesAdminList";
import RecipeAdminEdit from "./pages/RecipeAdminEdit";
import PricesAdminList from "./pages/PricesAdminList";
import PriceAdminEdit from "./pages/PriceAdminEdit";
import AdminChromaCollection from "./pages/admin/AdminChromaCollection";
import AdminNormalizedProducts from "./pages/admin/AdminNormalizedProducts";
import AdminPgvector from "./pages/admin/AdminPgvector";
import AdminOpenFoodFacts from "./pages/admin/AdminOpenFoodFacts";

const adminRoutes = () => (
    <Routes>
        {/* Standalone login page */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Admin area wrapped in TailAdmin-like layout */}
        <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Admin />} />
            <Route path="dashboard" element={<Admin />} />
            <Route path="categories" element={<CategoriesAccordion />} />
            <Route path="product/:productId" element={<ProductEdit />} />
            <Route path="products" element={<Products />} />
            <Route path="recipes" element={<RecipesAdminList />} />
            <Route path="recipes/:id" element={<RecipeAdminEdit />} />
            <Route path="prices" element={<PricesAdminList />} />
            <Route path="prices/:id" element={<PriceAdminEdit />} />
            <Route path="chroma" element={<AdminChromaCollection />} />
            <Route path="normalized" element={<AdminNormalizedProducts />} />
            <Route path="pgvector" element={<AdminPgvector />} />
            <Route path="openfoodfacts" element={<AdminOpenFoodFacts />} />
        </Route>
    </Routes>
);

export default adminRoutes;